import React from 'react';
import TopbarLayout from './TopbarLayout';

// Wrapper for Topbar with right alignment
const TopbarRightLayout = (props) => {
  return <TopbarLayout {...props} headerAlignment="right" />;
};

export default TopbarRightLayout; 